import script from "./MatchStartView.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchStartView.vue?vue&type=script&setup=true&lang=js"

import "./MatchStartView.vue?vue&type=style&index=0&id=70abd09c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70abd09c"]])

export default __exports__